import cn from 'clsx';
import {useReservation} from 'context/reservation';
import {useCustomTheme} from 'context/customTheme';
import chekinLogoIcon from 'assets/icons/accept-icon.svg?no-inline';
import styles from './styles.module.css';

function Header() {
  const {housing} = useReservation();
  const {data: template} = useCustomTheme();
  const logo = template?.navigation_title_logo ?? chekinLogoIcon;
  const propertyName = housing?.name || 'Property Name';

  return (
    <header className="hidden md:flex items-center p-4 simple-page__header">
      <div className="flex items-center simple-page__logo-container">
        <img
          src={logo}
          width={48}
          height={48}
          alt="Logo"
          className="mr-2 simple-page__logo"
        />
      </div>
      <span className={cn(styles.propertyName, 'simple-page__propertyName')}>
        {propertyName}
      </span>
    </header>
  );
}

export {Header};
